module.exports = __webpack_public_path__ + "static/media/soundBtn.f032452d.svg";